var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditpenicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.99927 12.2679V14.9346H4.49927L11.8726 7.0697L9.3726 4.40303L1.99927 12.2679ZM13.8059 5.00748C14.0659 4.73015 14.0659 4.28215 13.8059 4.00481L12.2459 2.34081C11.9859 2.06348 11.5659 2.06348 11.3059 2.34081L10.0859 3.64215L12.5859 6.30881L13.8059 5.00748Z",
    fill: "black",
    fillOpacity: 0.54
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditpenicon);
export default __webpack_public_path__ + "static/media/editpenicon.343e076d86ced2af082c87ef17ac4098.svg";
export { ForwardRef as ReactComponent };